import { useState } from "react";
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import {  Typography, Box, Accordion, AccordionSummary } from "@mui/material";
 
 

const Billing = () => {
  // Set the default expanded state to the first accordion (panel0)
  const [expanded, setExpanded] = useState("panel0");

  // Data for each accordion
  const accordionData = [
    {
      title: "Flexibility:",
      content: "Pay only for the exact days you need coverage, avoiding unnecessary costs for unused days.",
      image: "/img/rentshield/billing_flexibility.webp",
    },
    {
      title: "Cost-Effectiveness:",
      content: "Eliminates the risk of overpaying for services during slower periods or gaps in usage.",
      image: "/img/rentshield/billing_cost effective.webp",
    },
    {
      title: "Scalability:",
      content: "Pay only for the exact days you need coverage, avoiding unnecessary costs for unused days.",
      image: "/img/rentshield/billing_scalability.webp",
    },
    {
      title: "Transparency:",
      content: "Clear, itemized daily charges help you track expenses more accurately and manage budgets effectively.",
      image: "/img/rentshield/billing_Transparency.webp",
    },
  ];


  const handleAccordionChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  return (

 

            <div className="row">
                <div className="col-lg-6 col-sm-6">
                  <div className="onRentNewLeft">
                          {accordionData.map((accordion, index) => (
                            expanded === `panel${index}` ? (
                              <Box key={index} sx={{ textAlign: 'center' }}>
                                <img
                                  src={accordion.image}
                                  alt={`logo for ${accordion.title}`}
                                />
                              </Box>
                            ) : null
                          ))}
                  </div>
                </div>

                <div className="col-lg-6 col-sm-6">
                  <div className="onRentNewRight">
                      <h3>Billed <span>Per Day,</span> only when needed</h3>
                      {accordionData.map((accordion, index) => (
                        <Box key={index} className="boxAccordian">
                          <Accordion className="headingAccordian"
                            expanded={expanded === `panel${index}`}
                            onChange={handleAccordionChange(`panel${index}`)}
                          >
                            <AccordionSummary
                                    expandIcon={<ExpandMoreIcon />}
                                    aria-controls="panel1-content"
                                    >
                              
                              <Typography>
                                {accordion.title}
                              </Typography>
                            </AccordionSummary>
                          </Accordion>
                          {/* Content below the accordion button */}
                          {expanded === `panel${index}` && (
                            <Box className="summaryAccordian">
                              <Typography>{accordion.content}</Typography>
                            </Box>
                          )}
                        </Box>
                      ))}
                  </div>
                </div>

            </div>
 
    
  );
};

export default Billing;
